import colors from '../../themes/colors';

const title = {
  textTransform: 'uppercase',
  display: 'inline-block',
  padding: '2px 15px 2px 10px',
  marginRight: -10,
  borderBottomLeftRadius: 500,
  borderTopLeftRadius: 500,
  backgroundColor: colors.blue,
  color: '#fff',
  fontFamily: 'Roboto, sans-serif',
  fontSize: 14,
  cursor: 'pointer',
  boxShadow:
    'rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
};

const style = {
  saveButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: -20,
    bottom: -6
  },
  title: title,
  disabledTitle: {
    ...title,
    cursor: 'default',
    color: 'rgba(0, 0, 0, 0.3)',
    backgroundColor: 'rgb(224, 224, 224)'
  }
};

export default style;



// WEBPACK FOOTER //
// ./src/components/SaveButton/style.js